import { inject } from 'vue';

import { Provider } from './provider';

export const iocProviderKey = Symbol('iocProvider');

export function useIocProvider(): Provider {
  return inject(iocProviderKey) as Provider;
}
